import React, { useEffect, useState } from 'react'
import { ToastContainer } from 'react-toastify';

import { ICustomNotification, INotificationComponent, INotificationFunction, INotificationParameter } from '../../../types/custom_notifications';
import { IMetaParameter } from '../../../types/meta_paramter';

import 'react-toastify/dist/ReactToastify.css';

import MainLayout from '../../layouts/MainLayout';

import DeleteModal from '../../modals/DeleteModal';
import Modal from '../../modals/Modal';

import useGetCustomNotifications from '../../../hooks/custom_notifications/useGetCustomNotifications';
import useGetMetaFunctions from '../../../hooks/meta-function/useGetMetaFunctions';

import CustomNotificationSidebar from '../../subcomponents/custom_notifications/Sidebar';
import CustomNotification from '../../subcomponents/custom_notifications/CustomNotification';
import NotificationComponent from '../../subcomponents/custom_notifications/NotificationComponent';
import NotificationFunction from '../../subcomponents/custom_notifications/NotificationFunction';
import NotificationParameter from '../../subcomponents/custom_notifications/NotificationParameter';
import TestNotificationModal from '../../modals/TestNotificationModal';

const CustomNotifications = () => {
    const newCustomNotification: ICustomNotification = {
        status: 'inactive',
        method: 'and',
        notification: {
            title: '',
            description: '',
        },
        notification_components: [] as INotificationComponent[]
    };

    const newNotificationComponent: INotificationComponent = {
        custom_notification_id: 0,
        description: '',
        method: 'and',
        notification_functions: [] as INotificationFunction[]
    };

    const newNotificationFunction: INotificationFunction = {
        name: '',
        description: '',
        notification_component_id: 0,
        notification_parameters: [] as INotificationParameter[]
    };

    const newNotificationParameter: INotificationParameter = {
        name: '',
        description: '',
        value: '',
        notification_function_id: 0
    };

    const [customNotifications, setCustomNotifications] = useState<ICustomNotification[]>([]);
    const [currOption, setCurrOption] = useState<number[]>([]);
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState<boolean>(false);
    const [isDelete, setIsDelete] = useState<boolean>(false);
    const [isAction, setIsAction] = useState<boolean>(false); // eslint-disable-line
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
    const [isOpenTestNotificationModal, setIsOpenTestNotificationModal] = useState<boolean>(false);
    const [deleteModalMessage, setDeleteModalMessage] = useState<{ title: string; subtitle: string }>({ title: '', subtitle: '' });
    const [currCustomNotification, setCurrentCustomNotification] = useState<ICustomNotification>(!!customNotifications[currOption[0]] ? customNotifications[currOption[0]] : newCustomNotification);
    const [currNotificationComponent, setCurrentNotificationComponent] = useState<INotificationComponent>(!!currCustomNotification.notification_components[currOption[1]] ? currCustomNotification.notification_components[currOption[1]] : newNotificationComponent);
    const [currNotificationFunction, setCurrentNotificationFunction] = useState<INotificationFunction>(!!currNotificationComponent.notification_functions[currOption[2]] ? currNotificationComponent.notification_functions[currOption[2]] : newNotificationFunction);
    const [currNotificationParameter, setCurrentNotificationParameter] = useState<INotificationParameter>(!!currNotificationFunction.notification_parameters[currOption[3]] ? currNotificationFunction.notification_parameters[currOption[3]] : newNotificationParameter);
    const [isResetNew, setIsResetNew] = useState<boolean>(false);
    const [relatedMetaParameters, setRelatedMetaParameters] = useState<IMetaParameter[]>([]);


    const { data: allCustomNotifications, isPending, isError } = useGetCustomNotifications();
    const { data: metaFunctions, isPending: isPendingMetaFunctions, isError: isErrorMetaFunctions } = useGetMetaFunctions('notification');

    useEffect(() => {
        if (!currOption.length) {
            setCurrOption([0]);
        }
        setCustomNotifications(allCustomNotifications ? allCustomNotifications : []);
    }, [allCustomNotifications]); //eslint-disable-line

    useEffect(() => {
        if (currOption.length >= 1) {
            setCurrentCustomNotification(customNotifications[currOption[0]] ? customNotifications[currOption[0]] : newCustomNotification);
        }
        if (currOption.length >= 2) {
            setCurrentNotificationComponent(customNotifications[currOption[0]].notification_components[currOption[1]] ? customNotifications[currOption[0]].notification_components[currOption[1]] : { ...newNotificationComponent, custom_notification_id: customNotifications[currOption[0]].id ?? 0 });
        }
        if (currOption.length >= 3) {
            setCurrentNotificationFunction(customNotifications[currOption[0]].notification_components[currOption[1]].notification_functions[currOption[2]] ? customNotifications[currOption[0]].notification_components[currOption[1]].notification_functions[currOption[2]] : { ...newNotificationFunction, notification_component_id: customNotifications[currOption[0]].notification_components[currOption[1]].id ?? 0 });
        }
        if (currOption.length >= 4) {
            setCurrentNotificationParameter(
                customNotifications[currOption[0]].notification_components[currOption[1]].notification_functions[currOption[2]].notification_parameters[currOption[3]]
                    ? customNotifications[currOption[0]].notification_components[currOption[1]].notification_functions[currOption[2]].notification_parameters[currOption[3]]
                    : { ...newNotificationParameter, notification_function_id: customNotifications[currOption[0]].notification_components[currOption[1]].notification_functions[currOption[2]].id ?? 0 });

        }

    }, [customNotifications, currOption]); //eslint-disable-line

    useEffect(() => {
        if (metaFunctions && currNotificationFunction.id) {
            setRelatedMetaParameters(metaFunctions.find(metaFunction => metaFunction.name === currNotificationFunction.name)?.parameters || []);
        }
    }, [currNotificationFunction, metaFunctions]); //eslint-disable-line

    if (isPending || isPendingMetaFunctions) return <div>Loading...</div>
    if (isError || isErrorMetaFunctions) return <div>Error</div>

    return (
        <>
            {isOpenDeleteModal && <DeleteModal setIsOpenDeleteModal={setIsOpenDeleteModal} setIsDelete={setIsDelete} title={deleteModalMessage.title} subtitle={deleteModalMessage.subtitle} />}
            {isOpenModal && <Modal setIsOpenModal={setIsOpenModal} setIsAction={setIsAction} title={deleteModalMessage.title} subtitle={deleteModalMessage.subtitle} />}
            {isOpenTestNotificationModal && <TestNotificationModal setIsModalOpen={setIsOpenTestNotificationModal} customNotificationId={currCustomNotification.id ?? 0} />}
            <MainLayout>
                <div className='imm_admin__main_view'>
                    <CustomNotificationSidebar currOption={currOption} setCustomNotifications={setCustomNotifications} setCurrOption={setCurrOption} customNotifications={customNotifications} isResetNew={isResetNew} setIsResetNew={setIsResetNew} />
                    <div className='imm_admin__main_content'>
                        {currOption.length === 1 && <CustomNotification setIsOpenTestNotificationModal={setIsOpenTestNotificationModal} setDeleteModalMessage={setDeleteModalMessage} currOption={currOption} setCurrOption={setCurrOption} customNotification={currCustomNotification} isDelete={isDelete} setIsDelete={setIsDelete} setIsOpenDeleteModal={setIsOpenDeleteModal} disableDelete={customNotifications.length === 1} setIsResetNew={setIsResetNew} />}
                        {currOption.length === 2 && <NotificationComponent setDeleteModalMessage={setDeleteModalMessage} currOption={currOption} setCurrOption={setCurrOption} notificationComponent={currNotificationComponent} isDelete={isDelete} setIsDelete={setIsDelete} setIsOpenDeleteModal={setIsOpenDeleteModal} setIsResetNew={setIsResetNew} />}
                        {currOption.length === 3 && <NotificationFunction isOpenModal={isOpenModal} isAction={isAction} setIsOpenModal={setIsOpenModal} setIsAction={setIsAction} setDeleteModalMessage={setDeleteModalMessage} currOption={currOption} setCurrOption={setCurrOption} notificationFunction={currNotificationFunction} isDelete={isDelete} setIsDelete={setIsDelete} setIsOpenDeleteModal={setIsOpenDeleteModal} setIsResetNew={setIsResetNew} metaFunctions={metaFunctions} />}
                        {currOption.length === 4 && <NotificationParameter setDeleteModalMessage={setDeleteModalMessage} currOption={currOption} setCurrOption={setCurrOption} notificationParameter={currNotificationParameter} isDelete={isDelete} setIsDelete={setIsDelete} setIsOpenDeleteModal={setIsOpenDeleteModal} setIsResetNew={setIsResetNew} relatedMetaParameters={relatedMetaParameters} />}
                    </div>
                </div>
                <ToastContainer toastStyle={{ fontFamily: 'Poppins', fontSize: '14px' }} autoClose={2000} />
            </MainLayout>
        </>
    );
}

export default CustomNotifications;